import * as React from 'react';
import * as types from '../../types';
import * as services from '../../services';
import GroupsList from './GroupsList';
import { DefaultButton } from '@fluentui/react/lib/Button';
import styles from '../../styles/cr.module.scss';
import { IIAPAction } from '../../types';

export interface IGroupActionsTabProps extends types.IBaseComponentProps {
    onItemTitleClick: (ID: number, title: string, filteredItems: any[]) => void;
    iapActionId: any;
    onShowList: () => void;
}

export interface ILookupData {
}

export class LookupData implements ILookupData {
}

export interface IGroupActionsTabState {
    Loading: boolean;
    LookupData: ILookupData;
    IAPInfo: IIAPAction;
    FilteredItemsMainList: any[];
    ListFilterText: string;
}

export class GroupActionsTabState implements IGroupActionsTabState {
    public Loading = false;
    public LookupData = new LookupData();
    public IAPInfo = null;
    public IAPActionId: number = 0;
    public ActionOwnerPermission = false;
    public FilteredItemsMainList: any[] = null;
    public HideNextButton: boolean = false;
    public ListFilterText: string = null;
}

export default class GroupActionsTab extends React.Component<IGroupActionsTabProps, IGroupActionsTabState> {
    private iapUpdateService: services.IAPActionService = new services.IAPActionService();
    constructor(props: IGroupActionsTabProps, state: IGroupActionsTabState) {
        super(props);
        this.state = new GroupActionsTabState();
    }

    public render(): React.ReactElement<IGroupActionsTabProps> {
        return (
            <div className={styles.cr} style={{ width: '98%' }}>
                {this.renderSectionTitle()}
                {this.renderInfoTable()}
                {this.renderGroupsList()}
                {this.renderFormButtons()}
            </div>
        );
    }

    private renderSectionTitle() {
        return (
            <React.Fragment>
                <h1 className={styles.headings2}>Manage Group Actions</h1>
            </React.Fragment>
        );
    }

    private renderInfoTable() {
        const iapInfo = this.state.IAPInfo;
        if (iapInfo === null) return;
        const iapTitle: string = iapInfo.Title;
        let iapDetails: string = iapInfo.Details;
        //replace all
        iapDetails = iapDetails.split('\n').join('<br/>');
        return (
            <React.Fragment>
                <div style={{ marginBottom: '20px', marginTop: '50px' }} className={styles.sectionATitle}>Details</div>
                <div className="info-table-container">
                    <table className="info-table" style={{ width: '100%' }} cellSpacing="0" cellPadding="10">
                        <tbody>
                            <tr>
                                <td className="label">
                                    Title
                                </td>
                                <td className="value">
                                    {iapTitle}
                                </td>
                            </tr>
                            <tr>
                                <td className="label">
                                    Action
                                </td>
                                <td className="value">
                                    <div dangerouslySetInnerHTML={{ __html: iapDetails }} ></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </React.Fragment>
        );
    }

    private renderGroupsList() {
        const iapInfo = this.state.IAPInfo;
        if (iapInfo === null) return;

        return (
            <React.Fragment>
                <div style={{ marginBottom: '20px', marginTop: '20px' }} className={styles.sectionATitle}>Groups</div>
                {<div>
                    <div style={{ width: 'auto', minHeight: '120px', marginTop: '10px', marginLeft: 'auto', marginRight: 'auto' }}>
                        <GroupsList
                            {...this.props}
                            parentActionId={Number(this.props.iapActionId)}
                            onItemTitleClick={this.props.onItemTitleClick}
                            errorHandling={this.props.errorHandling}
                            filterText={this.state.ListFilterText}
                            onChangeFilterText={this.handle_ChangeFilterText}
                        />
                    </div>
                    <br /><br />
                </div>}
            </React.Fragment>
        );
    }

    private renderFormButtons() {
        const iapInfo = this.state.IAPInfo;
        if (iapInfo === null) return;

        return (
            <div style={{ marginTop: '30px' }}>
                {
                    <React.Fragment>
                        <DefaultButton text="Close" className={styles.formButton} style={{ marginRight: '5px' }}
                            onClick={this.props.onShowList}
                        />
                    </React.Fragment>
                }
            </div>
        );
    }

    private loadIAPInfo = (): void => {
        this.iapUpdateService.read(this.props.iapActionId).then((u: IIAPAction) => {
            this.setState({
                IAPInfo: u,
            });
        }, (err) => {
            if (this.props.errorHandling?.onError) this.props.errorHandling?.onError(`Error loading rec info`, err.message);
        });
    }

    protected loadLookups(): Promise<any> {
        return Promise.all([
            this.loadIAPInfo()
        ]);
    }

    public componentDidMount(): void {
        this.setState({
            Loading: true,
        }, this.callBackFirstLoad);
    }

    private callBackFirstLoad = (): void => {
        let loadingPromises = [this.loadLookups()];
        Promise.all(loadingPromises).then(p => this.setState({ Loading: false })).catch(err => this.setState({ Loading: false }));
    }

    protected cloneObject(obj, changeProp?, changeValue?) {
        if (changeProp)
            return { ...obj, [changeProp]: changeValue };
        return { ...obj };
    }

    private handle_ChangeFilterText = (value: string): void => {
        this.setState({ ListFilterText: value });
    }
}